import { Stripe, StripeCardNumberElement } from "@stripe/stripe-js";

export enum ECardElementStatus {
    CARD_NUMBER = "cardNumber",
    CARD_EXPIRY = "cardExpiry",
    CARD_CVC = "cardCvc",
}

export interface IBilling {
    firstName: string | null;
    lastName: string | null;
    company: string | null;
    streetAddress: string | null;
    extendedAddress: string | null;
    locality: string | null;
    region: string | null;
    postalCode: string | null;
    countryName: string | null;
}

export interface IAddCreditCard {
    stripe: Stripe;
    cardElement: StripeCardNumberElement;
    cardholderName: string;
    onSuccess: () => void;
}

interface IThreeDSecureUsage {
    supported: boolean;
}

export interface ICardAddress {
    city: string | null;
    country: string | null;
    line1: string | null;
    line2: string | null;
    postal_code: string | null;
    state: string | null;
}

export interface ICardBillingDetails {
    address: ICardAddress;
    email: string | null;
    name: string | null;
    phone: string | null;
}

interface ICardNetworks {
    available: string[];
    preferred: string | null;
}

export interface ICardChecks {
    address_line1_check: string | null;
    address_postal_code_check: string | null;
    cvc_check: string | null;
}

export interface ICard {
    object: string;
    brand: string;
    checks: ICardChecks;
    country: string;
    exp_month: number;
    exp_year: number;
    fingerprint: string;
    funding: string;
    generated_from: string | null;
    last4: string;
    networks: ICardNetworks;
    three_d_secure_usage: IThreeDSecureUsage;
    wallet: string | null;
}

export interface ICardDetails extends ICard {
    id: string;
}

export interface IPaymentMethod {
    id: string;
    object: string;
    billing_details: ICardBillingDetails;
    card: ICard;
    created: number;
    customer: string;
    livemode: boolean;
    metadata: Record<string, unknown>;
    type: string;
}

export interface IUser {
    _id: string;
    name: string;
    surname: string;
    gender: string;
    username: string;
    birthDate: string;
    phone: string;
    email: string;
    cognitoId?: string;
    favouriteTours?: string[]; // Object Id tour preferiti
    orders?: string[]; // Object Id degli ordini
    status?: string;
    createdAt?: string;
    updatedAt?: string;
    paymentMethods?: IPaymentMethod[];
    bio?: string;
    usernameFacebook?: string;
    city?: string;
    taxIdCode?: string;
    address?: string;
    language?: string;
    usernameInstagram?: string;
    usernameTwitter?: string;
    displayName?: string;
    lastUpdate?: string;
    marketingPromotions: boolean;
    policyPrivacy: boolean;
    terms: boolean;
    avatar: string;
    coupons?: string[];
    cityOfBirth?: string;
    country?: string;
    county?: string;
    zipCode?: string;
}

export interface ISignUpTo {
    username: string;
    password: string;
    name: string;
    surname: string;
    email: string;
    birthDate?: string;
    country: string;
    marketingPromotions: boolean;
}

export interface ISignUpVerification {
    username: string;
    code: string;
}

export type TSignUp = {
    email: string;
    name: string;
    surname: string;
    password: string;
    country: string;
    confirmPassword: string;
};
